import { useMutation, useQuery } from '@tanstack/react-query'
import { getAccountStatus, getAccounts, getPersons, orderCard } from './endpoints.ts'
import { orderCardDtoMapper } from './mappers.ts'
import type { OrderCardRequest } from './types.ts'

export const useGetAccounts = (customerId: string) =>
  useQuery({
    queryKey: ['accounts', customerId],
    queryFn: () => getAccounts(customerId),
    staleTime: 0,
  })

export const useGetNonTopAccounts = (customerId: string) =>
  useQuery({
    queryKey: ['NON_TOP_UP_ACCOUNTS', customerId],
    queryFn: () => getAccounts(customerId),
    staleTime: 0,
    select: (data) => data.filter((account) => account.accountType !== 'TOP_ACCOUNT' && account.accountType !== 'PERSONAL_TOP_ACCOUNT'),
  })

export const useGetPersons = (customerId: string) =>
  useQuery({
    queryKey: ['persons', customerId],
    queryFn: () => getPersons(customerId),
    staleTime: 0,
  })

export const useGetAccountStatus = (customerId: string, accountId: string | undefined) =>
  useQuery({
    queryKey: ['accountStatus', customerId, accountId],
    queryFn: () => getAccountStatus(customerId, accountId ?? 'will-never-happen'),
    staleTime: 0,
    enabled: accountId ? accountId.length > 0 : false,
  })

export const useOrderCardV3 = (customerId: string) =>
  useMutation({
    mutationKey: ['orderCard'],
    mutationFn: (cardRequest: OrderCardRequest) => orderCard(customerId, orderCardDtoMapper(cardRequest)),
  })
